import React from 'react'

import { formatCurrency } from '../../common/js/currency-utility';
import { type WebLicense2 } from '../../common/types/webshop.types';
import { type RecurringRepairLicense } from '../types/recurring-repair.types';

type Props = {
    license: RecurringRepairLicense,
    currencyIso: string
}

export default function LicenseItem({license, currencyIso}: Props) {
    if (!license){
        return <></>
    }
    const weblic: WebLicense2 = license.weblic;
    const prod = weblic.prod;

    const price = formatCurrency(license.renewalCost, currencyIso)

    return (
        <div className='line-item-row license-item box'>
            <div className='line-items-product'>
                <img src={prod.imgSrc} />
                <div>
                    <span><strong>{prod.familyName}</strong></span>
                    <span>{prod.hostLabel}</span>
                    <span>{prod.typeLabel}</span>
                </div>
            </div>
            {license && (
            <div className='line-items-license'>
                <span>{weblic.serial}</span>
            </div>
            )}
            <div className='line-items-price'>
                <span>{price}</span>
            </div>
        </div>
  )
}
